module.exports = __webpack_public_path__ + "img/temperature-goal-slide3.b217cff6.gif";